import React from 'react';

import './route-loader.scss';

const RouteLoader = () => (
    <div className="RouteLoader" />
);

export default RouteLoader;
